import { AuthService } from '../../authorization/services';
import env from '../../config';

class UploaderController {

    private onCompleteAll: any;
    private onCompleteItem: any;
    private onUpload: any;

    private url: any;

    private uploadOptions: any;
    private uploader: any;

    constructor(
        private AuthService: AuthService,
        private FileUploader: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.uploadOptions = {
            url: env.API_URL + this.url,
            removeAfterUpload: true,
            headers: {
                'Authorization': 'Bearer ' + this.AuthService.GetAuthorizationData()
            },
           
        }

        this.uploader = new this.FileUploader();
        this.uploader.onCompleteItem = (item, response, status, headers) => {
             this.onCompleteItem({item: item, response: response, status: status, headers: headers});
        }
        this.uploader.onCompleteAll = () => {
            this.onCompleteAll();
            this.onUpload();
        }
    }
}

export const uploaderComponent = {
    bindings: {
        url : "<",
        single: "<",
        onUpload: "&",
        onCompleteItem: "&",
        onCompleteAll: "&"
        
    },
    controller: UploaderController,
    template: require('./uploader.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/shared/uploader.component.ts